import { IoIosHome, IoIosContact } from 'react-icons/io';
import { SiAboutdotme } from 'react-icons/si';
import { MdWork } from 'react-icons/md';

export const navLinks = [
  {
    id: 1,
    url: '/',
    label: 'Home',
    icon: <IoIosHome />,
  },
  {
    id: 2,
    url: '/about',
    label: 'About',
    icon: <SiAboutdotme />,
  },
  {
    id: 3,
    url: '/work',
    label: 'Work',
    icon: <MdWork />,
  },
  {
    id: 4,
    url: '/contact',
    label: 'Contact',
    icon: <IoIosContact />,
  },
];
